import gql from 'graphql-tag';

export const mutationCreateOneTimeAccessToken = gql`
  mutation createOneTimeAccessToken {
    createOneTimeAccessToken
  }
`;

export default mutationCreateOneTimeAccessToken;
